import React from 'react';
import { MapPin, CheckCircle } from 'lucide-react';
import { serviceAreas } from '../data/mock';

export const ServiceAreas = () => {
  return (
    <section id="areas" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4">
            Serving <span className="text-primary">Central Florida</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Proud to serve homeowners and businesses throughout Central Florida
            with professional roofing services you can trust.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Map Placeholder */}
          <div className="relative">
            <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-gray-100">
              <div className="flex items-center justify-center mb-8">
                <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center">
                  <MapPin className="w-10 h-10 text-primary" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-center text-secondary mb-4">
                Central Florida Service Area
              </h3>
              <p className="text-center text-muted-foreground mb-6">
                We proudly serve the following counties and surrounding areas:
              </p>
              
              <div className="grid grid-cols-2 gap-4">
                {serviceAreas.map((area, index) => (
                  <div
                    key={index}
                    className="flex items-start space-x-2 p-3 bg-gray-50 rounded-lg hover:bg-primary/5 transition-colors"
                  >
                    <CheckCircle className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                    <span className="text-secondary font-medium">{area}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Info Section */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-gray-100">
              <h3 className="text-2xl font-bold text-secondary mb-6">
                Your Local Roofing Experts
              </h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-bold text-secondary mb-2">
                      Serving All of Central Florida
                    </h4>
                    <p className="text-muted-foreground">
                      From Marion to Brevard County, we bring professional roofing
                      services to your doorstep with prompt, reliable service.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-bold text-secondary mb-2">
                      Fast Response Times
                    </h4>
                    <p className="text-muted-foreground">
                      Being local means we can respond quickly to your roofing needs throughout
                      Central Florida, whether it's an emergency repair or scheduled installation.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-bold text-secondary mb-2">
                      Don't See Your City?
                    </h4>
                    <p className="text-muted-foreground">
                      We may still service your area! Give us a call to discuss your
                      roofing project—we're happy to travel for the right job.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-primary rounded-2xl shadow-xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">
                Ready to Get Started?
              </h3>
              <p className="mb-6 text-white/90">
                Contact us today for a free, no-obligation estimate on your roofing
                project. We're here to answer all your questions.
              </p>
              <button
                onClick={() =>
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
                }
                className="w-full bg-white text-primary hover:bg-gray-100 font-bold py-4 px-6 rounded-lg transition-colors"
              >
                Request Free Estimate
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
